/* RESPONSIBLE TEAM: team-proactive-support */
import ContentEditorRoute from 'embercom/routes/apps/app/content/edit';
export default ContentEditorRoute.extend({
  analytics: {
    section: 'messages',
    place: 'banner_editor',
  },
});
